export const firstCapitalLetter = (str: string) => {
  if (typeof str === 'string') {
    return str.charAt(0).toUpperCase() + str.substring(1);
  } else {
    return 'Error';
  }
};
